module.exports = __webpack_public_path__ + "img/icono_cafe.aff63f90.svg";